import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

export type WorkSession = {
  $id: string;
  clockIn: string;
  clockOut?: string;
  totalWorkTime: number;
};

export async function getMonthlyWorkSessions(
  userId: string,
  year: number,
  month: number,
): Promise<WorkSession[]> {

  const ecuadorStartDate = new Date(year, month - 1, 1, 0, 0, 0, 0);
  const ecuadorEndDate = new Date(year, month, 0, 23, 59, 59, 999);
  const start = new Date(ecuadorStartDate.getTime() + (5 * 60 * 60 * 1000)).toISOString();
  const end = new Date(ecuadorEndDate.getTime() + (5 * 60 * 60 * 1000)).toISOString();

  const res = await databases.listDocuments(
    import.meta.env.VITE_APPWRITE_DATABASE_ID!,
    import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID!,
    [
      Query.equal("userId", userId),
      Query.greaterThanEqual("clockIn", start),
      Query.lessThanEqual("clockIn", end),
      Query.orderAsc("clockIn"),
    ],
  );

  const sessions: WorkSession[] = (res.documents as any[]).map(doc => {
    let totalHours = 0;
    if (doc.clockIn && doc.clockOut) {
      const inMs = new Date(doc.clockIn).getTime();
      const outMs = new Date(doc.clockOut).getTime();
      const diffMs = outMs - inMs;
      if (!isNaN(diffMs) && diffMs > 0) {
        totalHours = parseFloat((diffMs / (1000 * 60 * 60)).toFixed(2));
      }
    }

    return {
      $id: doc.$id,
      clockIn: doc.clockIn,
      clockOut: doc.clockOut,
      totalWorkTime: totalHours,
    };
  });

  return sessions;
}
